import React from "react";


import { NavbarBroker } from "../NavbarBroker";
import { NavbarMobileBroker } from "../NavbarMobileBroker";
import { Calendar } from "./Calendar";

const Schedule = () => {
    return (
        <NavbarBroker titulo="Agenda">
            <Calendar />
            <NavbarMobileBroker />
        </NavbarBroker>
    );
};

export default Schedule;
